<template>
  <div class="classes-detail-tabs">
    <BlockTabs :items="tabs" currentClass="bold5" isNew @changeTab="changeTab"></BlockTabs>
    <template v-if="currentTab == 1">
      <Rich
        class="classes-detail-introduction"
        v-html="detail.introduction"
        v-if="detail.introduction"
        oncontextmenu="return false"
        onselectstart="return false"
      ></Rich>
      <EmptyNew class="classes-detail-empty" v-else title="暂无内容" />
    </template>
    <template v-if="currentTab == 2">
      <div class="classes-detail-courses">
        <div v-for="course in detail.courses" :key="course.id" class="classes-detail-course">
          <img class="classes-detail-course_cover" :src="course.cover_img" />
          <div class="classes-detail-course_main">
            <div>
              <router-link
                class="classes-detail-course_title bold6"
                :to="{ name: 'CourseShow', params: { id: course.id } }"
              >
                {{ course.title }}
              </router-link>
              <div class="classes-detail-course_info">
                <span>共{{ course.section_num }}课时</span>
                <template v-if="course.start_play_date">
                  <span class="classes-detail-course_line">|</span>
                  <span>
                    {{ course.start_play_date | tsFormatDate }}-{{
                      course.end_play_date | tsFormatDate
                    }}
                  </span>
                </template>
              </div>
            </div>
            <div class="classes-detail-course_bottom">
              <div class="classes-detail-course_teachers">
                <template v-for="(teacher, index) in course.teachers">
                  <div
                    v-if="index < 5"
                    :key="teacher.teacher_id"
                    class="classes-detail-course_teacher"
                    :class="{
                      'classes-detail-course_teacher-more':
                        course.teachers.length > 5 && index == 4,
                    }"
                    :more="`共${course.teachers.length}位讲师`"
                  >
                    <img
                      class="classes-detail-course_teacher-avatar"
                      :src="teacher.teacher_avatar"
                    />
                    <div class="classes-detail-course_teacher-name eps">
                      {{ teacher.teacher_name }}
                    </div>
                  </div>
                </template>
              </div>
              <CurrencyNew
                :price="course.price"
                :priceUnderline="course.underlined_price"
                :priceTwo="true"
              ></CurrencyNew>
            </div>
          </div>
        </div>
      </div>
      <div class="classes-detail-course_tip">购买班级后班级课程直接赠送，无需购买</div>
    </template>
  </div>
</template>
<script>
import EmptyNew from '@/components/EmptyNew.vue';

export default {
  name: 'ClassesDetailTabs',
  components: { EmptyNew },
  props: {
    detail: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      currentTab: 1,
      tabs: [
        { id: 1, name: '班级介绍' },
        { id: 2, name: '班级课程' },
      ],
    };
  },
  methods: {
    changeTab(tab) {
      this.currentTab = tab.id;
    },
  },
};
</script>
<style lang="scss" scoped>
.classes-detail-tabs {
  background: #ffffff;
  border-radius: 4px;
  padding: 8px 24px 8px 20px;
  position: relative;

  ::v-deep {
    .tab-item {
      width: auto !important;
      margin-right: 32px !important;
    }
  }
}
.classes-detail-introduction {
  padding: 12px 0 16px 4px;
}
.classes-detail-empty {
  padding: 87px 0 51px 0;
}
.classes-detail-course_tip {
  color: #916b34;
  line-height: 20px;
  position: absolute;
  top: 28px;
  right: 24px;
  padding-right: 22px;
  background: url('~@/assets/images/classes/info@2x.png') no-repeat right center/16px 16px;
}
.classes-detail-courses {
  padding-top: 16px;
}
.classes-detail-course {
  display: flex;
  padding: 24px 0;
  border-bottom: 1px solid #e6e6e6;
  &:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }

  ::v-deep {
    .price-wrap {
      margin-bottom: 3px;
      .price-underline {
        margin-right: 8px;
      }
      .price {
        font-size: 24px;
      }
      .price-zero {
        font-size: 20px;
      }
    }
  }
}
.classes-detail-course_cover {
  width: 210px;
  height: 140px;
  margin-right: 24px;
}
.classes-detail-course_main {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.classes-detail-course_title {
  font-size: 16px;
  font-family: PingFangSC, PingFangSC-Semibold;
  line-height: 22px;
  margin-bottom: 6px;
}
.classes-detail-course_info {
  color: #999999;
  line-height: 20px;
}
.classes-detail-course_line {
  margin: 0 10px;
}
.classes-detail-course_bottom {
  display: flex;
  justify-content: space-between;
}
.classes-detail-course_teachers {
  display: flex;
  flex: 1;
}
.classes-detail-course_teacher {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 16px;
  position: relative;
  max-width: 56px;

  &:last-child {
    margin-right: 0;
  }
}
.classes-detail-course_teacher-avatar {
  width: 32px;
  height: 32px;
  border: 1px solid #f2f2f2;
  border-radius: 50%;
  box-sizing: border-box;
  margin-bottom: 2px;
}
.classes-detail-course_teacher-name {
  color: #999999;
  line-height: 22px;
  width: 100%;
}
.classes-detail-course_teacher-more::after {
  content: attr(more);
  background: rgba($color: $primary-color, $alpha: 0.1);
  color: $primary-color;
  padding: 2px 8px;
  border-radius: 12px;
  border-bottom-left-radius: 0;
  position: absolute;
  white-space: nowrap;
  top: -4px;
  left: 48px;
}
</style>
